import { Children, cloneElement, useContext, useEffect, useState } from 'react';

import { useDepartmentGetQuery } from '../../Common/Queries/departmentQueries';
import { useLevelsGetQuery } from '../../Common/Queries/levelQueries';
import { useSkillsGetQuery } from '../../Common/Queries/skillQueries';
import { useUpdateStreamQueryById } from '../../Common/Queries/streamQueries';
import { useUsersGetQuery } from '../../Common/Queries/usersQueries';

import { isLogin } from '../../utils';

import { ALL_DATA_LIMIT, AuthContext, DURATION_TIME, ROLES } from '../../constants';

/**
 * @function formateData
 * @param values
 * @returns formated values
 */
export const formateData = (values) => values;

export function EditStreamContainer(props) {
  const putToStream = useUpdateStreamQueryById();

  const { formData } = props;
  const [values, setValues] = useState(formData);

  useEffect(() => setValues(formData), [formData]);
  const { userInfo } = useContext(AuthContext);
  const role = userInfo?.roles?.[0];
  // Manager
  const managerList = useUsersGetQuery(
    {
      limit: ALL_DATA_LIMIT,
      role: [ROLES.ADMIN, ROLES.HIRING_MANAGER, ROLES.SUPER_ADMIN, ROLES.TENANT_OWNER].join(','),
    },
    {
      enabled: isLogin() && role !== ROLES.AGENCY,
      refetchInterval: DURATION_TIME,
      refetchIntervalInBackground: true,
    }
  );

  // Skills
  const skillList = useSkillsGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  // Departments
  const departmentList = useDepartmentGetQuery(
    { limit: ALL_DATA_LIMIT },
    {
      enabled: isLogin() && role !== ROLES.AGENCY,
      refetchInterval: DURATION_TIME,
      refetchIntervalInBackground: true,
    }
  );

  // Levels
  const levelList = useLevelsGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  /**
   * this function is utility function for submit data get by user
   * @param e default parameter
   */
  function handleOnSubmit(e, body) {
    e.preventDefault();
    const reqBody = formateData(body);
    const reqParams = { reqBody, reqId: props.streamId };
    putToStream.mutate(reqParams);
  }

  // for closing pop over after update stream
  useEffect(() => {
    if (putToStream.isSuccess) props.setOpen(false);
  }, [putToStream.isSuccess]);

  const children = Children.only(props.children);
  return cloneElement(children, {
    values: values || {},
    putToStream,
    handleOnSubmit,
    managerList,
    skillList,
    departmentList,
    levelList,
  });
}
